<template>
  <div>
    <!-- S I G N U P  T I T L E -->
    <div class="text-center">
      <p class="text-24 md:text-47 font-bold">hello ivy for {{ type }} <span v-if="type === 'personal'">use</span></p>
      <p v-if="type === 'teams'" class="text-20 text-grey-20">You’ll get an unlimited, free 15-day trial of all features.</p>
      <p v-if="type === 'personal'" class="text-20 text-grey-20">Tell us a bit about yourself.</p>
    </div>

    <InputModule
      ref="firstNameINputRef"
      v-model="account.firstName"
      name="firstName"
      type="text"
      label="Your first name"
      placeholder="Alex"
      class="w-full mt-30"
      input-classes="px-22 py-13 rounded-10 border border-grey-10 focus:border-brand anim-all text-17"
      label-class="mb-5 font-bold"
      shadow="focus:shadow-signup"
      :has-background="false"
      :error-message="errorMessages.firstName"
      @clearErrorMessage="name => errorMessages[name] = null"
    />
    <InputModule
      v-model="account.lastName"
      name="lastName"
      type="text"
      label="Your last name"
      placeholder="Johnson"
      class="w-full mt-20"
      input-classes="px-22 py-13 rounded-10 border border-grey-10 focus:border-brand anim-all text-17"
      label-class="mb-5 font-bold"
      shadow="focus:shadow-signup"
      :has-background="false"
      :error-message="errorMessages.lastName"
      @clearErrorMessage="name => errorMessages[name] = null"
    />

    <ButtonModule
      text="Create account"
      class="w-full justify-center bg-brand hover:bg-brand-hover text-white rounded-10 mt-50 py-16 font-medium text-17"
      @click="next"
    />

    <p class="mt-20 text-grey-275 text-center md:px-20">
      By creating an account you acknowledge that you understood and agree with our terms and conditions and privacy policy.
    </p>
  </div>
</template>

<script>
import { defineComponent, nextTick, onMounted, reactive, ref } from 'vue'

import InputModule from '@/components/shared/form-controls/InputModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import { requiredFieldsValidation } from '@/helpers'

export default defineComponent({
  name: 'SignUpTeams',

  components: { InputModule, ButtonModule },

  props: {
    type: String,
    modelValue: Object,
    hasInvite: Boolean
  },

  emits: ['next', 'update:modelValue', 'nextToStep5'],

  setup (props, { emit }) {
    const firstNameINputRef = ref(null)

    const account = reactive({
      firstName: '',
      lastName: ''
    })

    const errorMessages = reactive({
      firstName: null,
      lastName: null
    })

    onMounted(() => {
      nextTick(() => {
        firstNameINputRef.value.focus()
      })
    })

    const next = () => {
      requiredFieldsValidation(errorMessages, account)

      if (Object.values(errorMessages).every(i => !i)) {
        emit('update:modelValue', {
          ...props.modelValue,
          firstName: account.firstName,
          lastName: account.lastName
        })

        if (props.hasInvite) return emit('nextToStep5')
        emit('next')
      }
    }

    return {
      // data
      account,
      errorMessages,
      firstNameINputRef,
      //  functions
      next
    }
  }
})
</script>
